import React, { useState, useEffect } from 'react';
import { googleLogin } from '../services/api';

const GOOGLE_CLIENT_ID = '977135259177-1tpp90bmrnr7dokqjuu1bh08h7p84neh.apps.googleusercontent.com';
const ADMIN_EMAILS = ['nehru00123@gmail.com', 'jawaharlalnehruelumalai@gmail.com'];

function Login({ onLogin }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const initGoogle = () => {
      if (window.google?.accounts?.id) {
        try {
          window.google.accounts.id.initialize({
            client_id: GOOGLE_CLIENT_ID,
            callback: handleGoogleResponse,
            auto_select: false,
            cancel_on_tap_outside: true,
          });

          const container = document.getElementById('google-admin-btn');
          if (container && isMounted) {
            window.google.accounts.id.renderButton(container, {
              theme: 'filled_blue',
              size: 'large',
              shape: 'rectangular',
              text: 'signin_with',
              logo_alignment: 'left',
              width: 280,
            });
          }
        } catch (e) {
          console.warn('Google Identity initialization in admin:', e);
        }
      } else {
        setTimeout(initGoogle, 300);
      }
    };

    initGoogle();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleGoogleResponse = async (response) => {
    if (!response?.credential) return;

    setError('');
    setLoading(true);

    try {
      const payload = JSON.parse(atob(response.credential.split('.')[1]));
      const email = (payload.email || '').trim().toLowerCase();

      // Check if user is one of the authorized administrators
      if (!ADMIN_EMAILS.includes(email)) {
        setError(
          `Access Restricted: The account (${email}) is not authorized as an administrator. Only designated administrators have access.`
        );
        setLoading(false);
        return;
      }

      // Sync and obtain backend administrative JWT
      const res = await googleLogin({
        credential: response.credential,
        email: payload.email,
        name: payload.name,
        picture: payload.picture,
      });

      const token = res.data?.accessToken || response.credential;
      localStorage.setItem('adminToken', token);
      localStorage.setItem('adminUser', JSON.stringify({ email, name: payload.name }));
      onLogin();
    } catch (err) {
      console.error('Google Admin Login failed', err);
      setError(err.response?.data?.message || 'Google sign-in verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const triggerGooglePrompt = () => {
    if (window.google?.accounts?.id) {
      try {
        window.google.accounts.id.prompt();
      } catch (e) {
        setError('Google sign-in prompt failed. Please use the Google button above.');
      }
    } else {
      setError('Google services are still loading. Please wait a moment and try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card" style={{ maxWidth: '420px', textAlign: 'center', padding: '2.5rem' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <div
            style={{
              width: '64px',
              height: '64px',
              background: '#eff6ff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1rem',
              border: '1px solid #bfdbfe',
            }}
          >
            <svg style={{ width: '32px', height: '32px' }} viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
              />
            </svg>
          </div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1e293b', marginBottom: '0.5rem' }}>
            AskNehru Administration
          </h1>
          <p style={{ fontSize: '0.875rem', color: '#64748b', lineHeight: '1.4' }}>
            Secure sign-in for platform administrators. Manual password credentials have been retired.
          </p>
        </div>

        {error && (
          <div
            style={{
              padding: '0.75rem',
              background: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '8px',
              color: '#dc2626',
              fontSize: '0.85rem',
              marginBottom: '1.5rem',
              textAlign: 'left',
              lineHeight: '1.4',
            }}
          >
            {error}
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>
          <div id="google-admin-btn"></div>

          <button
            onClick={triggerGooglePrompt}
            disabled={loading}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              width: '100%',
              maxWidth: '280px',
              padding: '10px 16px',
              background: '#ffffff',
              color: '#1e293b',
              border: '1px solid #cbd5e1',
              borderRadius: '6px',
              fontSize: '0.875rem',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
            }}
          >
            {loading ? 'Authenticating...' : 'Sign in with Google'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
